var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7947 20.1596C39.458 20.1596 39.1863 1.16316 39.1863 1.16316C39.1863 0.826358 39.458 0.554688 39.7947 0.554688C40.1315 0.554688 40.4032 0.826358 40.4032 1.16316C40.4032 1.16316 40.1315 20.1596 39.7947 20.1596Z",
    fill: "url(#paint0_radial_13507_19062)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0232 28.7796C26.785 29.0177 13.1606 15.7766 13.1606 15.7766C12.9224 15.5384 12.9224 15.1532 13.1606 14.9169C13.3987 14.6787 13.7839 14.6787 14.0202 14.9169C14.0202 14.9169 27.2614 28.5414 27.0232 28.7796Z",
    fill: "url(#paint1_radial_13507_19062)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6049 40.3507C19.6049 40.6875 0.608468 40.9591 0.608468 40.9591C0.271671 40.9591 0 40.6875 0 40.3507C0 40.0139 0.271671 39.7422 0.608468 39.7422C0.608468 39.7422 19.6049 40.0139 19.6049 40.3507Z",
    fill: "url(#paint2_radial_13507_19062)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5098 39.7515C61.5098 39.4177 76.7021 39.1484 76.7021 39.1484C76.9714 39.1484 77.1887 39.4177 77.1887 39.7515C77.1887 40.0853 76.9714 40.3545 76.7021 40.3545C76.7021 40.3545 61.5098 40.0853 61.5098 39.7515Z",
    fill: "url(#paint3_radial_13507_19062)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5791 28.7796C52.3409 28.5414 65.5821 14.9169 65.5821 14.9169C65.8202 14.6787 66.2054 14.6787 66.4417 14.9169C66.6799 15.1551 66.6799 15.5403 66.4417 15.7766C66.4417 15.7766 52.8173 29.0177 52.5791 28.7796Z",
    fill: "url(#paint4_radial_13507_19062)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9656 25.3112C49.7312 25.1735 54.3663 16.9284 54.3663 16.9284C54.504 16.694 54.8073 16.6177 55.0399 16.7573C55.2725 16.8968 55.3507 17.1983 55.2111 17.4309C55.2111 17.4309 50.1982 25.4507 49.9656 25.3112Z",
    fill: "#404374"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8029 21.7577C34.5405 21.8247 31.9875 12.7181 31.9875 12.7181C31.9205 12.4558 32.0787 12.1878 32.3429 12.1208C32.6072 12.0538 32.8733 12.212 32.9402 12.4762C32.9402 12.4762 35.0671 21.6907 34.8029 21.7577Z",
    fill: "#404374"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7357 27.7684C18.598 28.0028 10.353 23.3677 10.353 23.3677C10.1186 23.23 10.0423 22.9267 10.1818 22.6941C10.3195 22.4596 10.6228 22.3833 10.8554 22.5229C10.8554 22.5229 18.8753 27.5358 18.7357 27.7684Z",
    fill: "#404374"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.213 35.3463C63.146 35.0839 72.2526 32.531 72.2526 32.531C72.5149 32.464 72.7829 32.6222 72.8499 32.8864C72.9169 33.1488 72.7587 33.4167 72.4945 33.4837C72.4945 33.4837 63.28 35.6105 63.213 35.3463Z",
    fill: "#404374"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3992 22.118C45.0829 22.0361 48.4751 7.97063 48.4751 7.97063C48.5569 7.6543 48.8807 7.46451 49.197 7.54638C49.5134 7.62825 49.7032 7.95202 49.6213 8.26835C49.6213 8.26835 45.7174 22.1998 45.3992 22.118Z",
    fill: "url(#paint5_radial_13507_19062)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0056 23.4399C30.7228 23.6055 23.1755 11.2612 23.1755 11.2612C23.0099 10.9784 23.1048 10.6155 23.3858 10.4518C23.6668 10.288 24.0315 10.3811 24.1952 10.6621C24.1952 10.6621 31.2847 23.2743 31.0037 23.4399H31.0056Z",
    fill: "url(#paint6_radial_13507_19062)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8849 34.3144C16.8376 34.4935 8.69912 32.5736 8.69912 32.5736C8.51609 32.5272 8.40627 32.344 8.45364 32.165C8.50101 31.9859 8.68835 31.8785 8.87138 31.9248C8.87138 31.9248 16.9323 34.1343 16.8849 34.3144Z",
    fill: "url(#paint7_radial_13507_19062)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5392 30.3413C61.3736 30.0584 73.7179 22.5112 73.7179 22.5112C74.0007 22.3456 74.3636 22.4405 74.5273 22.7215C74.6911 23.0025 74.598 23.3672 74.3171 23.5309C74.3171 23.5309 61.7049 30.6204 61.5392 30.3394V30.3413Z",
    fill: "url(#paint8_radial_13507_19062)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5372 22.6148C38.2692 21.1223 40.3967 21.1223 41.1286 22.6148L45.5711 31.6736C45.9773 32.5018 46.8971 32.9448 47.7979 32.746L57.6502 30.5712C59.2735 30.2128 60.5999 31.8762 59.8894 33.379L55.5768 42.5004C55.1825 43.3343 55.4097 44.3297 56.1268 44.91L63.9699 51.2569C65.2621 52.3026 64.7887 54.3767 63.1707 54.7582L53.3505 57.0735C52.4527 57.2852 51.8161 58.0835 51.8095 59.0059L51.7374 69.0951C51.7256 70.7574 49.8087 71.6805 48.5017 70.6533L40.5687 64.4192C39.8434 63.8492 38.8224 63.8492 38.0971 64.4192L30.1641 70.6533C28.8571 71.6805 26.9403 70.7574 26.9284 69.0951L26.8563 59.0059C26.8497 58.0835 26.2131 57.2852 25.3153 57.0735L15.4951 54.7582C13.8771 54.3767 13.4037 52.3025 14.6959 51.2569L22.5391 44.91C23.2561 44.3297 23.4833 43.3343 23.089 42.5004L18.7764 33.379C18.0659 31.8762 19.3924 30.2128 21.0156 30.5712L30.8679 32.746C31.7687 32.9448 32.6886 32.5018 33.0947 31.6736L37.5372 22.6148Z",
    fill: "url(#paint9_linear_13507_19062)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2716 52.4123C35.8974 52.4123 35.5193 52.2713 35.2333 51.9875L30.5828 47.4051C30.0089 46.8393 30.0089 45.924 30.5828 45.3582C31.1568 44.7924 32.0853 44.7924 32.6593 45.3582L36.2716 48.9152L44.5304 40.7759C45.1044 40.2101 46.0329 40.2101 46.6069 40.7759C47.1809 41.3417 47.1809 42.257 46.6069 42.8228L37.3098 51.9875C37.0238 52.2713 36.6477 52.4123 36.2716 52.4123Z",
    fill: "#021239"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1432 63.4237C61.5319 62.7779 62.4681 62.7779 62.8568 63.4237L63.4273 64.3718C63.567 64.6038 63.7947 64.7692 64.0585 64.8303L65.1365 65.08C65.8708 65.2501 66.1601 66.1405 65.666 66.7097L64.9407 67.5453C64.7632 67.7498 64.6762 68.0175 64.6996 68.2873L64.7953 69.3897C64.8604 70.1406 64.1029 70.6909 63.4089 70.3969L62.3901 69.9653C62.1408 69.8596 61.8592 69.8596 61.6099 69.9653L60.5911 70.3969C59.8971 70.6909 59.1396 70.1406 59.2047 69.3897L59.3004 68.2873C59.3238 68.0175 59.2368 67.7498 59.0593 67.5453L58.334 66.7097C57.8399 66.1405 58.1292 65.2501 58.8635 65.08L59.9415 64.8303C60.2053 64.7692 60.433 64.6038 60.5727 64.3718L61.1432 63.4237Z",
    fill: "#254288"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0716 55.7119C71.2659 55.389 71.7341 55.389 71.9284 55.7119L72.5428 56.7328C72.6126 56.8488 72.7265 56.9316 72.8584 56.9621L74.0193 57.231C74.3865 57.316 74.5311 57.7613 74.2841 58.0459L73.5029 58.9457C73.4142 59.048 73.3707 59.1818 73.3824 59.3167L73.4854 60.5038C73.518 60.8793 73.1393 61.1545 72.7922 61.0075L71.695 60.5426C71.5704 60.4898 71.4296 60.4898 71.305 60.5426L70.2078 61.0075C69.8607 61.1545 69.482 60.8793 69.5146 60.5038L69.6176 59.3167C69.6293 59.1818 69.5858 59.048 69.4971 58.9457L68.7159 58.0459C68.4689 57.7613 68.6135 57.316 68.9807 57.231L70.1416 56.9621C70.2735 56.9316 70.3874 56.8488 70.4572 56.7328L71.0716 55.7119Z",
    fill: "#FFC568"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5607 62.808C15.75 62.4598 16.25 62.4598 16.4393 62.808L16.9738 63.7912C17.0635 63.9563 17.2382 64.0571 17.4259 64.0523L18.5447 64.0236C18.941 64.0134 19.1909 64.4463 18.984 64.7844L18.3998 65.739C18.3017 65.8992 18.3017 66.1008 18.3998 66.261L18.984 67.2156C19.1909 67.5537 18.941 67.9866 18.5447 67.9764L17.4259 67.9477C17.2382 67.9429 17.0635 68.0437 16.9738 68.2088L16.4393 69.192C16.25 69.5402 15.75 69.5402 15.5607 69.192L15.0262 68.2088C14.9365 68.0437 14.7618 67.9429 14.5741 67.9477L13.4553 67.9764C13.059 67.9866 12.8091 67.5537 13.016 67.2156L13.6002 66.261C13.6983 66.1008 13.6983 65.8992 13.6002 65.739L13.016 64.7844C12.8091 64.4463 13.059 64.0134 13.4553 64.0236L14.5741 64.0523C14.7618 64.0571 14.9365 63.9563 15.0262 63.7912L15.5607 62.808Z",
    fill: "#FFC568"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56072 52.808C5.75005 52.4598 6.24995 52.4598 6.43928 52.808L6.97383 53.7912C7.06354 53.9563 7.23816 54.0571 7.42592 54.0523L8.54471 54.0236C8.94096 54.0134 9.19092 54.4463 8.98399 54.7844L8.39976 55.739C8.30171 55.8992 8.30171 56.1008 8.39976 56.261L8.98399 57.2156C9.19092 57.5537 8.94096 57.9866 8.54471 57.9764L7.42592 57.9477C7.23816 57.9429 7.06354 58.0437 6.97383 58.2088L6.43928 59.192C6.24995 59.5402 5.75005 59.5402 5.56072 59.192L5.02617 58.2088C4.93646 58.0437 4.76184 57.9429 4.57408 57.9477L3.45529 57.9764C3.05904 57.9866 2.80908 57.5537 3.01601 57.2156L3.60024 56.261C3.69829 56.1008 3.69829 55.8992 3.60024 55.739L3.01601 54.7844C2.80908 54.4463 3.05904 54.0134 3.45529 54.0236L4.57408 54.0523C4.76184 54.0571 4.93646 53.9563 5.02617 53.7912L5.56072 52.808Z",
    fill: "#254288"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9478 32.7904) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3386 37.6144) scale(36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7163 40.0232) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8696 39.4269) scale(29.0409 35.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5698 37.6144) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3704 33.9989) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.541 33.9941) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3016 35.9299) scale(21.0109 20.5521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13507_19062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8106 36.3962) scale(36.3127 36.3127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13507_19062",
    x1: 39.3329,
    y1: 23.7965,
    x2: 38.2566,
    y2: 64.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25517,
    stopColor: "#FFC467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99F58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationStar);
export default __webpack_public_path__ + "static/media/ConfirmationStar.615d6a57812322077a2cebc783ab29d7.svg";
export { ForwardRef as ReactComponent };